import { render, staticRenderFns } from "./PrivateInvitationItem.vue?vue&type=template&id=76c4716d&"
import script from "./PrivateInvitationItem.vue?vue&type=script&lang=ts&"
export * from "./PrivateInvitationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports